export default function Spinner({ dark }) {
  return <span className={`spinner ${dark ? 'spinner-dark' : ''}`} />;
}
